export const assetSortEnum = {
  asset_id: 'asset_id',
  serial_number: 'serial_number',
  last_contact: 'last_contact',
} as const

export type AssetSortEnum = (typeof assetSortEnum)[keyof typeof assetSortEnum]

export type AssetSort = AssetSortEnum